export default __webpack_public_path__ + "static/media/03.522a6ff9.jpg";